import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Breadcrumb, Tooltip, Spin } from "antd";
import {
  TableOutlined,
  AppstoreOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import ShortlistedCompanyList from "./ShortlistedCompanyList";
import ShortlistedCompanyGrid from "./ShortlistedCompanyGrid";
import { CompanyAdmin, SuperAdmin } from "../../utils/Helper";
import { getRequest } from "../../axios";
import { ErrorNotificationMsg } from "../../utils/Notifications";

const ShortListedCompany = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [shortListedCompanyList, setShortListedCompanyList] = useState(true);
  const [shortListedCompanyGrid, setShortListedCompanyGrid] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isEmpty, setIsEmpty] = useState(true);

  const hideComponent = (name) => {
    switch (name) {
      case "shortListedCompanyList":
        setShortListedCompanyList(true);
        setShortListedCompanyGrid(false);
        break;
      case "shortListedCompanyGrid":
        setShortListedCompanyList(false);
        setShortListedCompanyGrid(true);
        break;
      default:
    }
  };

  const handleCountChange = (count) => {
    setIsEmpty(!count || count === 0);
  };

  useEffect(() => {
    const checkShortlisted = async () => {
      setLoading(true);
      try {
        const response = await getRequest(
          `facility/get-business-lounge/?shortlisted=true`,
          {
            page: 1,
            pagesize: 1,
            ordering: "id",
            search: "",
          }
        );

        if (
          response?.data?.success === false &&
          response?.data?.message === "No active subscription found."
        ) {
          navigate("/concierge");
          return;
        }

        if (response?.status === 200) {
          setIsEmpty(!(response.data.count > 0));
        }
      } catch (error) {
        ErrorNotificationMsg(error);
      } finally {
        setLoading(false);
      }
    };

    checkShortlisted();
  }, [navigate]);

  const colors = ["#D9E0E2"];

  return (
    <div className="contentpart">
      <div className="right_content_col">
        <div className="content_wraper ">
          <div className="businesslounge">
            <div className="loungetype shortlistcompany">
              <div className="pagename">
                <Tooltip
                  color={colors}
                  title={
                    <span style={{ color: "#000000" }}>
                      Shortlisted companies that align with your expectations
                      and enable you to connect with them.
                    </span>
                  }
                >
                  {t("shortlisted")}
                </Tooltip>

                <Breadcrumb>
                  <Breadcrumb.Item>
                    {SuperAdmin && <Link to="/dashboard">{t("home")}</Link>}
                    {CompanyAdmin && (
                      <Link to="/business-lounge">{t("home")}</Link>
                    )}
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>{t("shortlisted")}</Breadcrumb.Item>
                </Breadcrumb>
              </div>

              <div className="shortlist-action-bar">
                <Button
                  className="shortlist-lounge-btn"
                  onClick={() => navigate("/business-lounge")}
                >
                  {t("open_business_lounge")}
                </Button>
              </div>

              <div className="shortlist-main-panel">
                <p className="shortlist-subtitle">
                  {t("shortlisted_page_subtitle")}
                </p>

                <Spin spinning={loading}>
                  {!loading && isEmpty ? (
                    <div className="shortlist-empty-state">
                      <div className="shortlist-empty-state__icon">
                        <InfoCircleOutlined />
                      </div>
                      <h3>{t("shortlisted_empty_title")}</h3>
                      <p>{t("shortlisted_empty_desc")}</p>
                    </div>
                  ) : (
                    !loading && (
                      <>
                        <div className="viewiconwrap">
                          <Button
                            className={
                              shortListedCompanyList ? "card active" : ""
                            }
                            onClick={() =>
                              hideComponent("shortListedCompanyList")
                            }
                          >
                            <AppstoreOutlined />
                          </Button>
                          <Button
                            className={
                              shortListedCompanyGrid ? "grid active" : ""
                            }
                            onClick={() =>
                              hideComponent("shortListedCompanyGrid")
                            }
                          >
                            <TableOutlined />
                          </Button>
                        </div>
                        {shortListedCompanyList && (
                          <ShortlistedCompanyList
                            onCountChange={handleCountChange}
                          />
                        )}
                        {shortListedCompanyGrid && (
                          <ShortlistedCompanyGrid
                            onCountChange={handleCountChange}
                          />
                        )}
                      </>
                    )
                  )}
                </Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShortListedCompany;
